"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
/**
 * Supported formats
 */
var Format;
(function (Format) {
    Format["Emphasized"] = "Emphasized";
    Format["Link"] = "Link";
    Format["Strong"] = "Strong";
})(Format = exports.Format || (exports.Format = {}));
/**
 * Formatting function for non-Link formats. First looks through parts for any nested formatting.
 * If any are found, it sends the required parameters to checkNestedTextAndFormat to be formatted.
 * @param parts FormattedTextResult object to search for nested text and to build up the content
 * property in the returned FormattedText object
 * @param format Format used to grab the appropriate regular expression function and to add to the
 * returned FormattedText object
 * @param index Number used to look at that index in parts for nested formatting and to build up
 * the content in the returned FormattedText object
 * @returns FormattedText
 */
function genericFormatFn(regexpResult, format) {
    return {
        format: format,
        content: textFormatter(regexpResult[1]),
    };
}
/**
 * Link format parsing function
 * @param regexpResult RegExpExecArray results of an executed RegularExpression
 * @returns FormattedText
 */
function linkFormatFn(regexpResult) {
    // use the browser to help us parse the link
    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = regexpResult[0];
    var a = tempDiv.firstElementChild;
    var properties = {
        target: "_blank",
    };
    if (a) {
        SUPPORTED_LINK_ATTRIBUTES.forEach(function (attr) {
            var elementAttr = a.attributes.getNamedItem(attr);
            if (elementAttr) {
                properties[attr] = elementAttr.value;
            }
        });
        return {
            properties: properties,
            format: Format.Link,
            content: textFormatter(a.innerHTML),
        };
    }
    else {
        return {};
    }
}
var SUPPORTED_LINK_ATTRIBUTES = ["href", "title"];
/**
 * Object used to store utilities and functions for formatting.
 * Each key is a Format and each property is a FormatParser which contains
 * functions for formatting text based on its format, testing if the given text
 * matches a particular regular expression, or splitting text based
 */
var formatToFormatParser = (_a = {},
    _a[Format.Emphasized] = {
        formatFn: genericFormatFn,
        format: Format.Emphasized,
        regexFn: function (text) { return /\<em\>\<\/em\>|\<em\>(.+?)\<\/em\>/.exec(text); },
    },
    _a[Format.Link] = {
        formatFn: linkFormatFn,
        format: Format.Link,
        regexFn: function (text) { return /<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>/.exec(text); },
    },
    _a[Format.Strong] = {
        formatFn: genericFormatFn,
        format: Format.Strong,
        regexFn: function (text) { return /\<strong\>\<\/strong\>|\<strong\>(.+?)\<\/strong\>/.exec(text); },
    },
    _a);
/**
 * Returns the Format which first appears in the given text string.
 * If no formatting is found in the text, nothing is returned.
 *
 * @param text string text search for formatting
 * @returns { format: Format, result: RegExpExecArray } | undefined
 */
function findFirstFormatting(text) {
    // For each format, test the text against its regex and save to an object that
    // maps formats to indices
    var firstIndex = Infinity;
    var firstFormat = undefined;
    for (var format in Format) {
        var regExpObj = formatToFormatParser[format];
        var result = regExpObj.regexFn(text);
        if (result && result.index >= 0) {
            if (result.index < firstIndex) {
                firstIndex = result.index;
                firstFormat = { result: result, format: format };
            }
        }
    }
    return firstFormat;
}
/**
 * Function to be called by framework-specific formatting packages like loom-formatted-string-react
 * Takes in a string and returns a FormattedTextResult.
 * If any supported formatting is, the text will be recursively parsed to a FormattedText.
 * If no supported formatting is detected, then this simply returns the given text as an array.
 * If no string is being passed in, it will return an empty array.
 * @param text String which need to be formatted
 * @returns FormattedTextResult
 */
function textFormatter(text) {
    var firstFormat = findFirstFormatting(text);
    var parseTextResult = [];
    if (typeof text === "string") {
        if (firstFormat) {
            var format = firstFormat.format, result = firstFormat.result;
            var pre = text.substr(0, result.index);
            var postTextResult = textFormatter(text.substr(result.index + result[0].length));
            if (pre.length > 0) {
                parseTextResult.push(pre);
            }
            parseTextResult.push(formatToFormatParser[format].formatFn(result, format));
            if (postTextResult.length > 0) {
                parseTextResult.push.apply(parseTextResult, postTextResult);
            }
        }
        else if (text.length > 0) {
            parseTextResult.push(text);
        }
    }
    return parseTextResult;
}
exports.textFormatter = textFormatter;
//# sourceMappingURL=textFormatUtils.js.map